import { InfoModalConfig, MessageInitialState } from '../models';
import { ERROR_CODES, ERROR_CODE_TO_TRANSLATION_KEY, ErrorCode } from './error-codes.constants';

type ErrorCodeModalMap = Partial<Record<ErrorCode, InfoModalConfig>>;

export const EMAIL_CODE: MessageInitialState = {
  text: 'Transmit.mfs_email_otp_description',
  resendText: 'Transmit.mfs_email_otp_resend',
  title: 'Transmit.mfs_email_otp_title',
  invalidCode: false,
  email: true,
};

export const CONFIRM_REMOVE_TRUSTED_DEVICE: InfoModalConfig = {
  head: 'Transmit.confirm_remove_trusted_device_title',
  description: 'Transmit.confirm_remove_trusted_device_description',
  hasCancelBtn: true,
  type: 'info',
};

export const CONFIRM_REMOVE_TRUSTED_DEVICE_SUCCESS: InfoModalConfig = {
  head: 'Transmit.confirm_remove_trusted_device_success_title',
  description: 'Transmit.confirm_remove_trusted_device_success_description',
  hasCancelBtn: false,
  type: 'info',
};

export const ERROR_MESSAGES_DEFAULT: InfoModalConfig = {
  head: 'Transmit.generic_error_title',
  description: 'Transmit.generic_error_description',
  hasCancelBtn: false,
  type: 'info',
};

export const DUPLICATED_OPERATION_ERROR: InfoModalConfig = {
  head: '',
  description: 'Transmit.duplicated_operation_error',
  hasCancelBtn: false,
  type: 'info',
};

export const ERROR_CODE_MODAL_MAP: ErrorCodeModalMap = {
  [ERROR_CODES.DUPLICATED_OPERATION]: DUPLICATED_OPERATION_ERROR,
  [ERROR_CODES.INVALID_INIT_OPTIONS]: ERROR_MESSAGES_DEFAULT,
  [ERROR_CODES.INVALID_TOKEN]: ERROR_MESSAGES_DEFAULT,
  [ERROR_CODES.INVALID_USER]: ERROR_MESSAGES_DEFAULT,
  [ERROR_CODES.MISSING_PARAMETERS]: ERROR_MESSAGES_DEFAULT,
  [ERROR_CODES.UNKNOWN_DEVICE]: ERROR_MESSAGES_DEFAULT,
  [ERROR_CODES.USER_NOT_FOUND]: ERROR_MESSAGES_DEFAULT,
};

export function getModalConfigForErrorCode(errorCode?: string): InfoModalConfig {
  if (!errorCode) return ERROR_MESSAGES_DEFAULT;

  return (
    ERROR_CODE_MODAL_MAP[errorCode as ErrorCode] ??
    ERROR_CODE_TO_TRANSLATION_KEY[errorCode as keyof typeof ERROR_CODE_TO_TRANSLATION_KEY] ??
    ERROR_MESSAGES_DEFAULT
  );
}
